import { render, staticRenderFns } from "./BiCruzfarmaRed.vue?vue&type=template&id=d304253a"
import script from "./BiCruzfarmaRed.vue?vue&type=script&lang=js"
export * from "./BiCruzfarmaRed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports